import script from "./SelectPoleMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectPoleMenu.vue?vue&type=script&lang=ts&setup=true"

import "./SelectPoleMenu.vue?vue&type=style&index=0&id=332c9fd4&lang=scss"

const __exports__ = script;

export default __exports__